// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"854e5ea4","171":"75975d5e","374":"3969f947","404":"2be7f33c","447":"cef25587","715":"2a9e503b","895":"3b4bcd31"}[chunkId] + ".chunk.js";
};